<template>
  <div>
    <dd-pill v-if="critical" :small="false" color="#ff0000">Kritiek</dd-pill>
    <dd-pill v-else-if="important" :small="false" color="#ee7600">Belangrijk</dd-pill>
    <dd-pill v-else-if="normal" :small="false" type="primary">Normaal</dd-pill>
    <dd-pill v-else-if="insignificant" :small="false" color="#757575">Insignificant</dd-pill>
  </div>
</template>

<script>
export default {
  name: "TaskPriority.vue",
  props: {
    cellProps: {
      type: String,
      required: true,
    },
  },
  computed: {
    priority() {
      return this.cellProps;
    },
    critical() {
      return this.priority == 0;
    },
    important() {
      return this.priority == 1;
    },
    normal() {
      return this.priority == 2;
    },
    insignificant() {
      return this.priority == 3;
    },
  },
};
</script>

<style scoped>

</style>
